import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { auth, getUser } from "../../utils/auth";
import { consumeAuthBridge } from "../../utils/authBridge";
import Loader from "../../Core/Loader/Loader";

/**
 * Landing route for cross-app SSO handoff (e.g. admin impersonation from
 * Epicenter). The new cy-sso session is delivered via the `_cy_auth_bridge`
 * cookie / `_spb` hash and consumed by `consumeAuthBridge()` at app bootstrap
 * (src/index.js) — which OVERWRITES `localStorage.user`, so an already
 * logged-in user is switched to the target account.
 *
 * We re-run consumeAuthBridge() here as a safety net (idempotent, never throws)
 * in case this component mounts via client-side navigation rather than a fresh
 * page load, then redirect into the app.
 */
const SSOLanding = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    try {
      consumeAuthBridge();
    } catch {
      /* never block */
    }
    setReady(true);
  }, []);

  if (!ready) return <Loader />;

  if (!auth()) {
    // Bridge failed / expired — fall back to the login route.
    return <Redirect to="/" />;
  }

  const user = getUser();
  return <Redirect to={user?.hasOwnProperty("parentId") ? "/parent-dashboard" : "/dashboard"} />;
};

export default SSOLanding;
